<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Translation</h4>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Key</label>
          <input class="form-control" [(ngModel)]="translationKey" placeholder="translation.key" type="text">
        </div>
        <div class="form-group">
          <label>Value</label>
          <textarea class="form-control" [(ngModel)]="translationValue" placeholder="Translation value" rows="3"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>
